import { useQuery } from '@tanstack/react-query';
import { usePLPQuery } from 'client/api/plp-results';
import { useLocation } from 'client/router/useLocation';
import useGlobalConfig from 'client/state/GlobalConfig';

const isBrowser = typeof window !== 'undefined';

const artificialDelayFn = () =>
  new Promise<boolean>((resolve) => {
    setTimeout(() => resolve(true), 50);
  });

const useIsUpdating = () => {
  const { apiURL, brand, pageType } = useGlobalConfig();
  const location = useLocation();

  const { isFetching: plpQueryFetching } = usePLPQuery();
  const { isFetching } = useQuery({
    queryKey: ['is-fetching', { apiURL, brand, pageType, url: `${location.pathname}${location.search}` }],
    queryFn: artificialDelayFn,
    initialData: true,
    staleTime: 0,
    enabled: isBrowser,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return plpQueryFetching || isFetching;
};

export default useIsUpdating;
